export default __webpack_public_path__ + "static/media/Content4.c022d867.png";